import React, { useState } from "react";
import "./responsable-person.component.scoped.scss";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import { UserRoles } from "../../types/userRoles";
import { icons } from "../../statics/icons";
import { ChangeKeyContactDialog } from "../../modules/case/dialogs/change-keycontact/change-keycontact.component";

interface ResponsablePersonComponentProps {
  user: any;
  loading?: boolean;
  title: string;
  editable: boolean;
}
export const ResponsablePersonComponent = (
  props: ResponsablePersonComponentProps,
) => {
  const { t } = useTranslation();
  const { user, loading, title, editable } = props;
  const [userImageError, setUserImageError] = useState(false);
  const [showChangeKeyContactDialog, setShowChangeKeyContactDialog] = useState(
    false,
  );
  return (
    <Box className="global__box__content p-0">
      <Box className="global__box__content__header">
        {loading ? (
          <Skeleton variant="text" width={200} height={20} />
        ) : (
          <Typography variant="h3" className="text-capitalize">
            {t(title)}
          </Typography>
        )}
      </Box>
      <Box className="global__box__content__body responsible__user">
        {loading ? (
          <Skeleton variant="circle" width={50} height={50} />
        ) : (
          <Box className="user__profile__pic">
            {user.profilePicURL && !userImageError ? (
              <img
                src={user.profilePicURL}
                title={user.name}
                alt=""
                onError={setUserImageError.bind(null, true)}
              />
            ) : (
              <span className="text-uppercase">
                {user.firstName ? user.firstName[0] + user.lastName[0] : ""}
              </span>
            )}
          </Box>
        )}
        <Box className="info">
          <Box className="d-flex align-items-center justify-content-between">
            {loading ? (
              <Skeleton variant="text" height={25} width={200} />
            ) : (
              <Typography variant="h3" color="textPrimary">
                {user.firstName + " " + user.lastName}{" "}
                <img src={icons.NAME_FLAG} alt="Flag" />
              </Typography>
            )}
            {!loading && editable && (
              <Typography
                variant="body1"
                className="font-weight-medium"
                style={{
                  color: "var(--accent-color)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setShowChangeKeyContactDialog(true)}
              >
                {t("EDIT")}
              </Typography>
            )}
          </Box>
          {loading ? (
            <Skeleton variant="text" height={20} width={150} />
          ) : (
            <a href={`mailto:${user.email}`}>{user.email}</a>
          )}
          {loading ? (
            <Skeleton variant="text" height={18} width={90} />
          ) : (
            <Typography variant="h4" color="textSecondary">
              {user.role !== UserRoles.SUPER_ADMIN ? (
                <>
                  {t(`ROLES.${user.role}`)} / {t(`ROLES.${user.group}`)}
                </>
              ) : (
                <>{t(`ROLES.${user.role}`)}</>
              )}
            </Typography>
          )}
        </Box>
      </Box>
      {showChangeKeyContactDialog && (
        <ChangeKeyContactDialog
          show={showChangeKeyContactDialog}
          onClose={() => setShowChangeKeyContactDialog(false)}
        />
      )}
    </Box>
  );
};
